 <div class="map-container">
  <div class="map-frame">
    <div id="mapInput2"></div>
  </div>
</div>
